import { connect } from 'react-redux'
import ArchivedFilesEntry from './archived-files-entry'
import { getArchivedFile } from '../../../../../../stores/archived-files/archived-files.selectors'
import { format } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const archivedFile = getArchivedFile(state, id)
  return {
    id: archivedFile.id,
    title: archivedFile.title,
    createdAt: format(archivedFile.created_at, 'DD.MM.YYYY'),
    link: `/assessment-files/${archivedFile.id}`,
    conclusion: archivedFile.concluded,
    student:
      archivedFile.student_type && archivedFile.student_type.account.full_name,
    thumb:
      archivedFile.works &&
      archivedFile.works[0] &&
      archivedFile.works[0].media[0].thumb_url,
    ageGroupTitle:
      archivedFile.student_types &&
      archivedFile.student_types[0] &&
      archivedFile.student_types[0].year_group &&
      archivedFile.student_types[0].year_group.title,
    ageGroupOrder:
      archivedFile.student_types &&
      archivedFile.student_types[0] &&
      archivedFile.student_types[0].year_group &&
      archivedFile.student_types[0].year_group.order
  }
}

export default connect(
  mapStateToProps,
  null
)(ArchivedFilesEntry)
